import { AddressType } from '@api';

type GetAddressSingleLineStringReturnType = string | undefined;

export const getAddressSingleLineString = ({
  street,
  addition,
  zip,
  city,
  country,
}: AddressType): GetAddressSingleLineStringReturnType => {
  const streetSegment = [street, addition].filter(Boolean).join(' ');
  const citySegment = [zip, city].filter(Boolean).join(' ');

  const singleLine = [streetSegment, citySegment, country]
    .filter(Boolean)
    .join(', ');

  return singleLine || undefined;
};

